import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onlinesedancabbookingpune() {



  const cardData = {




keyword: "Online Sedan Cab Booking Pune",

headingDescription: "Garud Cab Service provides convenient Online Sedan Cab Booking in Pune for airport transfers, corporate travel, family journeys, railway station transfers, local sightseeing, hotel pickups, and long-distance trips. Customers can book a chauffeur-driven sedan online according to their preferred pickup location, travel date, destination, and journey type. Our sedans are suitable for individuals, couples, and small families looking for comfortable seating, practical luggage space, private transportation, and dependable service. With clean vehicles, experienced drivers, flexible pickup arrangements, transparent pricing, easy booking assistance, and 24/7 customer support, Garud Cab Service makes online sedan booking simple and convenient for travel across Pune and popular destinations.",

topPlaces: [
  {
    title: "Katraj",
    description: "Katraj is an important southern Pune locality with residential areas, educational institutions, commercial establishments, and convenient road connections toward several Maharashtra destinations. Customers can book a sedan online for airport transfers, railway station travel, business requirements, family journeys, or longer road trips from Katraj. Garud Cab Service provides doorstep pickup with professional chauffeurs and flexible scheduling."
  },
  {
    title: "Aundh",
    description: "Aundh is a well-developed Pune neighborhood known for residential communities, shopping areas, restaurants, offices, and educational institutions. Residents and visitors can use online sedan booking for airport transfers, business meetings, hotel travel, and city transportation. A chauffeur-driven sedan offers a private and comfortable option for individuals and small families who prefer scheduled pickup and direct drop facilities."
  },
  {
    title: "Kondhwa",
    description: "Kondhwa is a growing residential and commercial area in Pune with convenient access to several parts of the city and nearby highways. Customers requiring private transportation can book a sedan online for airport journeys, family travel, corporate visits, railway station transfers, and sightseeing. Garud Cab Service provides flexible pickup arrangements and comfortable chauffeur-driven travel according to the customer's schedule."
  },
  {
    title: "Kothrud",
    description: "Kothrud is one of Pune's established residential neighborhoods and is known for educational institutions, shopping areas, restaurants, offices, and good city connectivity. Online sedan cab booking is useful for residents traveling to airports, railway stations, business locations, and nearby destinations. Customers can schedule a private vehicle in advance for convenient doorstep pickup and comfortable transportation."
  },
  {
    title: "Vishrantwadi",
    description: "Vishrantwadi is a well-connected Pune locality situated close to important roads and transportation corridors. It is convenient for passengers traveling toward Pune Airport, railway stations, business areas, and residential neighborhoods. Garud Cab Service allows customers to arrange sedan transportation online with flexible pickup times, professional drivers, comfortable seating, and practical luggage capacity."
  },
  {
    title: "Pimple Saudagar",
    description: "Pimple Saudagar is a popular residential and commercial neighborhood in the Pimpri-Chinchwad region with numerous apartments, offices, restaurants, and local businesses. Customers can book a sedan online for airport transfers, corporate travel, family outings, and intercity journeys. The service provides private doorstep transportation without the need to arrange a cab at the last minute."
  },
  {
    title: "Akurdi",
    description: "Akurdi is a prominent Pimpri-Chinchwad locality with residential communities, educational institutions, industrial areas, and railway connectivity. Online sedan booking can be useful for passengers traveling to Pune Airport, railway stations, corporate locations, or nearby cities. Garud Cab Service provides comfortable chauffeur-driven vehicles with advance booking and flexible pickup arrangements."
  },
  {
    title: "Nigdi",
    description: "Nigdi is located near the Mumbai-Pune Expressway and provides convenient road access toward Mumbai, Lonavala, and several other destinations. Customers can book a sedan online from Nigdi for airport transfers, business travel, family journeys, and longer road trips. With professional chauffeurs and comfortable vehicles, Garud Cab Service provides a convenient option for scheduled private transportation."
  },
  {
    title: "Warje",
    description: "Warje is a well-connected Pune neighborhood located along important road routes toward western Pune and the Mumbai-Pune corridor. Residents and visitors can use online sedan cab booking for airport travel, railway station transfers, corporate transportation, and family journeys. Customers can schedule doorstep pickup according to their preferred timing and destination."
  },
  {
    title: "Lohegaon",
    description: "Lohegaon is an important Pune locality situated close to Pune Airport and includes residential communities, educational institutions, and growing commercial areas. Online sedan booking is especially convenient for passengers requiring airport pickup and drop, hotel transfers, or onward travel to nearby cities. Garud Cab Service offers private chauffeur-driven transportation with flexible scheduling and luggage-friendly vehicles."
  }
],




"services": [
{
"name": "Online Sedan Cab Booking Pune",
"description": "Book Online Sedan Cab Booking Pune for convenient and comfortable chauffeur-driven transportation with clean AC vehicles and professional drivers. Choose a sedan for airport transfers, local travel, corporate transportation, family trips, sightseeing, one-way journeys, and outstation travel with flexible pickup and drop arrangements."
},
{
"name": "Sedan Taxi Service Pune",
"description": "Choose Sedan Taxi Service Pune for reliable private transportation with experienced chauffeurs, comfortable AC interiors, and convenient door-to-door pickup. Sedan taxis are suitable for individuals, couples, families, corporate travelers, airport passengers, sightseeing, local travel, and outstation journeys from Pune."
},
{
"name": "Sedan Cabs in Pune",
"description": "Book Sedan Cabs in Pune for comfortable city and outstation transportation with well-maintained air-conditioned vehicles and professional chauffeur service. Select a suitable sedan for airport transfers, office travel, family transportation, sightseeing, hotel transfers, one-way drops, and scheduled round trips."
},
{
"name": "Sedan Cab Service in Pune",
"description": "Choose Sedan Cab Service in Pune for dependable chauffeur-driven travel with comfortable seating, AC interiors, practical luggage space, and flexible pickup arrangements. The service is suitable for local rides, airport transfers, business travel, family journeys, tourist transportation, and outstation trips."
},
{
"name": "Sedan Cab Booking Pune",
"description": "Make Sedan Cab Booking Pune for scheduled private transportation with convenient pickup and direct destination drop. Select a comfortable sedan according to your passenger count and luggage requirements for airport travel, office visits, family trips, sightseeing, local transportation, and outstation journeys."
},
{
"name": "Sedan Taxi Booking Pune",
"description": "Reserve Sedan Taxi Booking Pune for comfortable and convenient travel with professional chauffeurs and clean air-conditioned cars. Sedan taxis are suitable for airport transfers, business meetings, personal visits, family travel, sightseeing, hotel transportation, and one-way or round-trip outstation journeys."
},
{
"name": "Sedan Car Rental Pune",
"description": "Hire Sedan Car Rental Pune with a professional chauffeur for flexible transportation across Pune and nearby destinations. Enjoy comfortable AC seating and practical luggage space with sedan options suitable for local travel, airport transfers, corporate requirements, family trips, sightseeing, and outstation journeys."
},
{
"name": "Sedan Cab Hire Pune",
"description": "Book Sedan Cab Hire Pune for private chauffeur-driven transportation with comfortable AC interiors and convenient pickup facilities. Sedan cabs are suitable for individuals, couples, families, corporate passengers, tourists, airport travelers, and customers planning local or long-distance journeys from Pune."
},
{
"name": "Sedan Outstation Cab Pune",
"description": "Choose Sedan Outstation Cab Pune for comfortable intercity travel with experienced chauffeurs and well-maintained air-conditioned vehicles. The service is suitable for one-way transfers, round trips, family travel, business journeys, sightseeing, personal visits, and long-distance transportation to destinations from Pune."
},
{
"name": "Sedan Airport Cab Pune",
"description": "Reserve Sedan Airport Cab Pune for convenient pickup and drop transportation to and from Pune Airport. Enjoy scheduled chauffeur service, comfortable AC seating, practical luggage space, and reliable travel arrangements suitable for business passengers, families, tourists, and individuals."
},
{
"name": "Sedan One Way Cab Pune",
"description": "Book Sedan One Way Cab Pune for a direct point-to-point journey without arranging return transportation. Enjoy private AC travel, professional chauffeur service, convenient pickup, and suitable sedan options for airport transfers, intercity travel, business trips, family journeys, and personal transportation."
},
{
"name": "Sedan Round Trip Cab Pune",
"description": "Choose Sedan Round Trip Cab Pune for convenient return transportation according to your planned travel schedule. Enjoy private AC travel, experienced chauffeur service, comfortable seating, and flexible pickup arrangements for sightseeing, family visits, business travel, weekend trips, and outstation journeys."
},
{
"name": "Affordable Sedan Cab Pune",
"description": "Book Affordable Sedan Cab Pune for economical and comfortable chauffeur-driven transportation with clean AC interiors and reliable service. Sedan options are suitable for local rides, airport transfers, family travel, office transportation, sightseeing, one-way drops, and outstation journeys while maintaining practical comfort."
},
{
"name": "Corporate Sedan Cab Pune",
"description": "Choose Corporate Sedan Cab Pune for professional transportation for employees, business meetings, client visits, airport transfers, and corporate events. Comfortable AC sedans with experienced chauffeurs provide convenient scheduled pickup, punctual travel arrangements, and private transportation for business requirements."
},
{
"name": "Maruti Suzuki Dzire Cab Service Pune",
"description": "Book Maruti Suzuki Dzire Cab Service Pune for comfortable and economical chauffeur-driven travel with AC interiors and practical luggage space. Dzire cabs are suitable for airport transfers, local transportation, corporate travel, family journeys, sightseeing, one-way trips, and outstation travel from Pune."
},
{
"name": "Hyundai Aura Cab Service Pune",
"description": "Choose Hyundai Aura Cab Service Pune for comfortable private transportation with professional chauffeurs and well-maintained air-conditioned vehicles. Hyundai Aura is suitable for airport transfers, office travel, family trips, sightseeing, hotel transfers, local rides, and outstation journeys from Pune."
},
{
"name": "Honda Amaze Cab Service Pune",
"description": "Book Honda Amaze Cab Service Pune for convenient chauffeur-driven transportation with comfortable AC interiors and spacious seating. The sedan is suitable for individuals, couples, families, corporate passengers, airport travelers, sightseeing, local transportation, and outstation journeys from Pune."
},
{
"name": "Swift Dzire on Rent Pune",
"description": "Hire Swift Dzire on Rent Pune with a professional chauffeur for comfortable local, airport, corporate, tourist, and outstation transportation. Enjoy an air-conditioned sedan with comfortable seating and practical luggage capacity for family travel, business requirements, sightseeing, one-way transfers, and round trips."
},
{
"name": "Hyundai Aura Cab in Pune",
"description": "Book Hyundai Aura Cab in Pune for reliable city, airport, corporate, and outstation transportation with professional chauffeur service. The comfortable AC sedan provides convenient seating and luggage space for individuals, families, tourists, business travelers, and passengers requiring private transportation."
},
{
"name": "Honda Amaze Taxi Pune",
"description": "Choose Honda Amaze Taxi Pune for comfortable private travel with experienced drivers, clean AC interiors, and convenient pickup arrangements. The sedan is suitable for local rides, airport transfers, office travel, family journeys, sightseeing, hotel transfers, and outstation transportation."
},
{
"name": "Sedan Airport Taxi Pune",
"description": "Reserve Sedan Airport Taxi Pune for convenient airport pickup and drop services with scheduled transportation and professional chauffeurs. Enjoy comfortable AC seating and practical luggage space for passengers traveling to or from Pune Airport for business, family, tourism, and personal requirements."
},
{
"name": "Sedan Outstation Taxi Pune",
"description": "Book Sedan Outstation Taxi Pune for reliable long-distance transportation with experienced chauffeurs and comfortable air-conditioned vehicles. Sedan taxis are suitable for one-way trips, round trips, family travel, business journeys, sightseeing, personal visits, and intercity transportation from Pune."
},
{
"name": "Sedan Family Cab Pune",
"description": "Choose Sedan Family Cab Pune for comfortable and private family transportation with spacious seating, AC interiors, professional chauffeur service, and convenient pickup arrangements. The service is suitable for airport transfers, family visits, sightseeing, weekend travel, local transportation, and outstation journeys."
},
{
"name": "Sedan Cab Service in Hinjewadi Pune",
"description": "Book Sedan Cab Service in Hinjewadi Pune for comfortable transportation to IT parks, offices, residential areas, Pune Airport, and outstation destinations. Professional chauffeur service and AC interiors make sedan cabs suitable for employees, corporate travelers, families, airport passengers, and personal travel."
},
{
"name": "Sedan Cab Service in Kharadi Pune",
"description": "Choose Sedan Cab Service in Kharadi Pune for reliable local, airport, corporate, and outstation transportation. Enjoy convenient pickup from homes, offices, hotels, and business locations with professional chauffeur service, comfortable AC seating, and practical luggage space for individuals and small families."
},
{
"name": "Sedan Cab Service in Hadapsar Pune",
"description": "Book Sedan Cab Service in Hadapsar Pune for convenient city and outstation travel with professional chauffeurs and comfortable AC vehicles. The service is suitable for office transportation, airport transfers, family journeys, sightseeing, hotel pickups, and private trips from Hadapsar to destinations across Maharashtra."
},
{
"name": "Sedan Cab Service in Baner Pune",
"description": "Reserve Sedan Cab Service in Baner Pune for comfortable transportation to offices, hotels, Pune Airport, residential areas, and outstation destinations. AC sedan vehicles provide convenient seating and luggage space for corporate travelers, families, tourists, and individuals requiring dependable chauffeur-driven travel."
},
{
"name": "Sedan Cab Service in Wakad Pune",
"description": "Hire Sedan Cab Service in Wakad Pune for convenient local, airport, corporate, and outstation transportation. Enjoy professional chauffeur service, clean AC interiors, comfortable seating, and scheduled pickup from homes, offices, hotels, and other locations in Wakad for private travel."
},
{
"name": "Sedan Cab Service in Pimpri Chinchwad",
"description": "Book Sedan Cab Service in Pimpri Chinchwad for reliable transportation across PCMC, Pune Airport, business locations, residential areas, and outstation destinations. Comfortable sedan vehicles are suitable for individuals, families, corporate passengers, tourists, and small groups seeking private chauffeur-driven travel."
},
{
"name": "Sedan Cab Service in Viman Nagar Pune",
"description": "Choose Sedan Cab Service in Viman Nagar Pune for convenient airport transfers, local travel, business transportation, and outstation journeys. Comfortable AC sedans with practical luggage space and professional chauffeurs are suitable for travelers staying near hotels, offices, residential areas, and Pune Airport."
},
{
"name": "Sedan Cab Service in Kothrud Pune",
"description": "Reserve Sedan Cab Service in Kothrud Pune for comfortable city rides, airport transfers, family travel, sightseeing, and outstation transportation. Enjoy convenient door-to-door pickup, experienced chauffeur service, AC seating, and practical sedan options for individuals, couples, families, and small groups."
},
{
"name": "Sedan Cab Service in Magarpatta Pune",
"description": "Book Sedan Cab Service in Magarpatta Pune for corporate travel, airport transfers, local transportation, hotel pickups, and outstation journeys. Comfortable AC sedans with professional chauffeurs are suitable for professionals, families, tourists, and individuals requiring scheduled private transportation from Magarpatta."
}
],
"tableData": [
["Online Sedan Cab Booking Pune", "Sedan Taxi Service Pune"],
["Sedan Cabs in Pune", "Sedan Cab Service in Pune"],
["Sedan Cab Booking Pune", "Sedan Taxi Booking Pune"],
["Sedan Car Rental Pune", "Sedan Cab Hire Pune"],
["Sedan Outstation Cab Pune", "Sedan Airport Cab Pune"],
["Sedan One Way Cab Pune", "Sedan Round Trip Cab Pune"],
["Affordable Sedan Cab Pune", "Corporate Sedan Cab Pune"],
["Maruti Suzuki Dzire Cab Service Pune", "Hyundai Aura Cab Service Pune"],
["Honda Amaze Cab Service Pune", "Swift Dzire on Rent Pune"],
["Hyundai Aura Cab in Pune", "Honda Amaze Taxi Pune"],
["Sedan Airport Taxi Pune", "Sedan Outstation Taxi Pune"],
["Sedan Family Cab Pune", "Sedan Cab Service in Hinjewadi Pune"],
["Sedan Cab Service in Kharadi Pune", "Sedan Cab Service in Hadapsar Pune"],
["Sedan Cab Service in Baner Pune", "Sedan Cab Service in Wakad Pune"],
["Sedan Cab Service in Pimpri Chinchwad", "Sedan Cab Service in Viman Nagar Pune"],
["Sedan Cab Service in Kothrud Pune", "Sedan Cab Service in Magarpatta Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Online Sedan Cab Booking in Pune Made Simple",
    WhyChoosedescription: "Garud Cab Service offers convenient online sedan cab booking in Pune for airport transfers, local travel, corporate transportation, family trips, railway station transfers, and outstation journeys."
  },
  {
    WhyChooseheading: "Reserve Your Cab Before the Journey",
    WhyChoosedescription: "Online booking allows you to arrange your sedan in advance by sharing your pickup point, destination, travel date, passenger details, and preferred trip type before your scheduled journey."
  },
  {
    WhyChooseheading: "Airport Transfers with Advance Planning",
    WhyChoosedescription: "Book a sedan online for Pune Airport pickup or drop and plan your transportation around your flight schedule, whether you are travelling from home, a hotel, office, or another location."
  },
  {
    WhyChooseheading: "Ideal for Business & Professional Travel",
    WhyChoosedescription: "Corporate travellers can use online sedan booking for meetings, client visits, office transfers, conferences, hotel transportation, and other business travel requirements."
  },
  {
    WhyChooseheading: "Easy Option for Family Travel",
    WhyChoosedescription: "Families and small groups can reserve a private sedan online according to their passenger count, luggage requirements, destination, and preferred travel schedule."
  },
  {
    WhyChooseheading: "Local & Outstation Booking Available",
    WhyChoosedescription: "Use online sedan booking for Pune city travel as well as suitable outstation routes, including holidays, family visits, religious journeys, sightseeing trips, and intercity transportation."
  },
  {
    WhyChooseheading: "One-Way, Round-Trip & Multi-Day Plans",
    WhyChoosedescription: "Select a one-way journey, return trip, or longer travel arrangement according to your itinerary, making online reservation useful for different types of personal and professional travel."
  },
  {
    WhyChooseheading: "Quick Booking Assistance from Garud",
    WhyChoosedescription: "Send your travel details to Garud Cab Service to discuss vehicle availability, trip requirements, pickup timing, and other booking details for your online sedan cab reservation."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Online Sedan Cab Booking in Pune?",
    answer: "Yes, Garud Cab Service provides online sedan cab booking in Pune for airport transfers, local travel, corporate transportation, family trips, railway station transfers, and outstation journeys."
  },
  {
    question: "How can I book a sedan cab online in Pune?",
    answer: "Share your pickup location, destination, travel date, passenger count, preferred vehicle, and trip type with Garud Cab Service to arrange your sedan booking."
  },
  {
    question: "Can I book a sedan online for Pune Airport?",
    answer: "Yes, sedan cabs can be booked online for Pune Airport pickup and drop according to your flight schedule and preferred travel time."
  },
  {
    question: "Can I make an outstation sedan booking online?",
    answer: "Yes, online sedan booking can be arranged for suitable outstation destinations from Pune based on your route, travel date, and vehicle availability."
  },
  {
    question: "Can I book a one-way sedan online?",
    answer: "Yes, one-way sedan cab arrangements can be booked when you need direct transportation from Pune to your selected destination."
  },
  {
    question: "Is online round-trip sedan booking available?",
    answer: "Yes, round-trip sedan bookings can be arranged for sightseeing, family visits, business travel, religious trips, holidays, and other return journeys."
  },
  {
    question: "Can I book a sedan online for corporate travel?",
    answer: "Yes, companies and business travellers can use online sedan booking for meetings, client transfers, office travel, airport transportation, and corporate events."
  },
  {
    question: "Can families reserve a sedan online?",
    answer: "Yes, families can reserve a private sedan according to passenger count, luggage requirements, destination, and preferred travel schedule."
  },
  {
    question: "Can I book a sedan in advance for an early flight?",
    answer: "Yes, advance online booking can be requested for early-morning airport transfers and other scheduled journeys based on vehicle availability."
  },
  {
    question: "How early should I book a sedan cab online?",
    answer: "Advance booking is recommended, especially for airport transfers, holidays, weekends, and planned outstation trips, so the required vehicle and schedule can be arranged."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Yash Kulkarni",
    feedback: "I arranged my Pune Airport sedan online before my travel date. Sharing the trip details in advance made the airport transfer easy to plan.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Komal Patil",
    feedback: "We booked a sedan online for a family outstation trip from Pune. The advance reservation helped us organize our travel without last-minute arrangements.",
    rating: 5
  }
];




  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Online Sedan Cab Booking Pune",
  "image": "https://garudcabs.com/assets/images/online-sedan-cab-booking-pune.webp",
  "description": "Book an Online Sedan Cab in Pune with Garud Cab for comfortable, reliable, and convenient local, airport, tourist, and outstation travel. Get easy Sedan taxi booking services for one way trips, round trips, airport transfers, business travel, family journeys, and sightseeing with convenient pickup and drop options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/online-sedan-cab-booking-pune"
  }
};




  return (
    <div>

<Helmet>
  <title>Online Sedan Cab Booking Pune | Sedan Taxi Service | +91 9970007784</title>

  <meta
    name="description"
    content="Book Online Sedan Cab in Pune with Garud Cab for local, airport, tourist, and outstation travel. Get reliable Sedan taxi and cab booking services with convenient one way, round trip, and airport transfer options."
  />

  <meta
    name="keywords"
    content="Online Sedan Cab Booking Pune, Sedan Taxi Service Pune, Sedan Cabs in Pune, Sedan Cab Service in Pune, Sedan Cab Booking Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/45.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onlinesedancabbookingpune;